export default "__VITE_ASSET__CgvA8oPz__"